import { languageHelper } from "../../../../config/helperFunctions";
import React, { useState } from "react";
import CartTable2 from "../../../../components/AdminTable/CardTable2";
// import Dropdown from "../../../../components/AdminDropdown/Dropdown";

function WasteReport() {
  const [columns] = useState([
    {
      header: languageHelper("SN"),
      accessorKey: "SN",
    },
    {
        header: languageHelper("Reference"),
        accessorKey: "Reference",
      },
    {
      header: languageHelper("Date"),
      accessorKey: "Date",
    },
   
    {
      header: languageHelper("Total Loss"),
      accessorKey: "Total Loss",
    },
    {
      header: languageHelper("Ingredient Count"),
      accessorKey: "Ingredient Count",
    },
    {
        header: languageHelper("Responsible Person"),
        accessorKey: "Responsible Person",
      },
  ]);
  const [data] = useState([]);
  const [buttonDataa] = useState([
    {
      buttonText: languageHelper("Submit"),
    },
  ]);

  const [selectButton] = useState([
    {
      placeholder: "User",
    }, 
  ]);
  return (
    <main>
      <CartTable2
        data={data}
        columns={columns}
        heading={languageHelper("Waste Report")}
        buttonDataa={buttonDataa}
        selectButton={selectButton}
      />
    </main>
  );
}

export default WasteReport;
